var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOutIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24562 5.40501L9.13847 1.623C9.7082 1.28209 10.4521 1.68829 10.4521 2.36889V3.50497H16.3233C16.8031 3.50497 17.1917 3.89393 17.1917 4.37333V7.99238C17.1917 9.13463 15.4549 9.13463 15.4549 7.99238V5.24168H10.4519V18.3637H15.4549V15.613C15.4549 14.4709 17.1917 14.4709 17.1917 15.613V19.232C17.1917 19.7118 16.8031 20.1004 16.3233 20.1004H10.4521L10.4488 21.2367C10.4493 21.8646 9.78929 22.2937 9.21064 22.0168L1.31779 18.2348C0.986384 18.1123 0.75 17.7934 0.75 17.4201L0.75352 6.18551C0.753872 5.86273 0.935328 5.55351 1.24562 5.40497L1.24562 5.40501ZM13.0858 10.7022C11.6405 10.7022 11.6405 12.9001 13.0858 12.9001H19.499L18.2542 14.1445C17.2327 15.166 18.7861 16.7199 19.8081 15.6984L22.922 12.5843C23.3416 12.1647 23.3768 11.4731 22.922 11.0183L19.8081 7.90416C18.7862 6.88266 17.2327 8.43636 18.2542 9.45804L19.499 10.7025H13.0858V10.7022Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutIcon);
export default __webpack_public_path__ + "static/media/logOutIcon.899a0590a9894a23e28fe3e47735dec5.svg";
export { ForwardRef as ReactComponent };